import { render, staticRenderFns } from "./RestrictedListEmailsSetModal.vue?vue&type=template&id=c09fbba6"
import script from "./RestrictedListEmailsSetModal.vue?vue&type=script&lang=js"
export * from "./RestrictedListEmailsSetModal.vue?vue&type=script&lang=js"
import style0 from "./RestrictedListEmailsSetModal.vue?vue&type=style&index=0&id=c09fbba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports